import React from 'react';
import { Label, MessageBar, MessageBarType, TextField} from '@fluentui/react';
import $ from 'jquery';

const Authentication = (props) => {

  return( 
    <div>
      <Label>Find your Outlook Access Key in AdvisorConX</Label>
      <Label>Setup > Outlook Add In</Label>
      <img src={require("./../../../assets/api2.png")} />
      <img src={require("./../../../assets/api.png")} />
      <Label>Copy and Paste Key below:</Label>
    <TextField id="authKey" variant="outlined"></TextField>
    <br/>
    </div>	
  );
}

export default Authentication;

